import React from 'react';

import styled from '@emotion/styled';

import { IconProps } from '../../IconsProps';

const StyledAdd = styled.svg<IconProps>`
  .cls-1,
  .cls-2 {
    fill: none;
  }

  .cls-2 {
    stroke: var(--chatbot-color-primary, #404040);
    stroke-miterlimit: 10;
  }

  .cls-3 {
    fill: var(--du-color-white, #fff);
  }

  .cls-4 {
    fill: var(--chatbot-color-primary, #404040);
  }

  &.disabled {
    .cls-2 {
      stroke: var(--du-color-grey, #969696);
    }

    .cls-4 {
      fill: var(--du-color-grey, #969696);
    }
  }

  &:hover,
  &.active {
    &:not([disabled]) {
      .cls-2 {
        stroke: var(--du-color-primary, #128370);
      }

      .cls-4 {
        fill: var(--du-color-primary, #128370);
      }
    }
  }
`;

const AddIcon: React.FC<IconProps> = ({ active, disabled }) => {
  let activeClass = disabled ? 'disabled' : active ? 'active' : undefined;
  const isTouch = !!('ontouchstart' in window) || window.navigator.maxTouchPoints > 0;
  activeClass = `${activeClass} ${!isTouch ? 'hover' : ''}`;
  return (
    <StyledAdd
      id='Add-Icon'
      xmlns='http://www.w3.org/2000/svg'
      width='32'
      height='32'
      viewBox='0 0 32 32'
      className={activeClass}
      disabled={disabled}
    >
      <rect id='Margin_Rectangle' data-name='Margin Rectangle' className='cls-1' width='32' height='32' />
      <rect
        id='Rectangle_422'
        data-name='Rectangle 422'
        className='cls-2'
        width='16'
        height='16'
        rx='1'
        transform='translate(8 8)'
      />
      <path id='gap' className='cls-3' d='M9.055,22.945V15.965L22.046,3,29,9.981,16.008,22.945Z' />
      <path
        id='Path_8802'
        data-name='Path 8802'
        className='cls-4'
        d='M22.5,12.011,20,9.515,13.01,16.5,12,20.01,15.507,19Z'
      />
      <path
        id='Rectangle_423'
        data-name='Rectangle 423'
        className='cls-4'
        d='M1,0H2.531a1,1,0,0,1,1,1V3.531a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V1A1,1,0,0,1,1,0Z'
        transform='translate(22.496 7.019) rotate(45)'
      />
    </StyledAdd>
  );
};

export default AddIcon;
